import React from 'react';

const EmptyList = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="153" height="132" viewBox="0 0 153 132" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="98.589%" y1="62.726%" y2="37.633%">
        <stop offset="0%" stopColor="#22C6BD" />
        <stop offset="100%" stopColor="#1BD7D1" />
      </linearGradient>
      <linearGradient id="prefix__b" x1="0%" x2="100%" y1="100%" y2="100%">
        <stop offset="0%" stopColor="#AB64F5" />
        <stop offset="100%" stopColor="#8D85EE" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle cx="84" cy="66" r="66" fill="#F1F5F7" fillRule="nonzero" />
      <g opacity=".6" transform="translate(0 15)">
        <rect width="111" height="56" fill="url(#prefix__a)" rx="4" />
        <g fill="#FFF" fillRule="nonzero">
          <path
            d="M1.765.407h53.841c.788 0 1.426.639 1.426 1.426 0 .788-.638 1.426-1.426 1.426H1.765C.977 3.26.339 2.621.339 1.833c0-.787.638-1.426 1.426-1.426z"
            opacity=".3"
            transform="translate(5.167 22.667)"
          />
          <path
            d="M1.765 11.815H15.92c.787 0 1.426.638 1.426 1.426 0 .787-.639 1.426-1.426 1.426H1.765c-.788 0-1.426-.639-1.426-1.426 0-.788.638-1.426 1.426-1.426z"
            opacity=".4"
            transform="translate(5.167 22.667)"
          />
          <path
            d="M1.765 20.37h28.33c.787 0 1.425.639 1.425 1.426 0 .788-.638 1.426-1.426 1.426H1.764c-.787 0-1.425-.638-1.425-1.426 0-.787.638-1.426 1.426-1.426z"
            opacity=".3"
            transform="translate(5.167 22.667)"
          />
        </g>
        <path
          fill="#FFF"
          d="M34.111 11.667h70.09c1.719 0 3.112 1.393 3.112 3.11 0 1.719-1.393 3.112-3.112 3.112h-70.09c-1.718 0-3.111-1.393-3.111-3.111 0-1.718 1.393-3.111 3.111-3.111zM8.111 11.667H24.89c1.718 0 3.111 1.393 3.111 3.11 0 1.719-1.393 3.112-3.111 3.112H8.11C6.393 17.889 5 16.496 5 14.778c0-1.718 1.393-3.111 3.111-3.111z"
          opacity=".261"
        />
      </g>
      <g opacity=".6">
        <path
          fill="#99F"
          d="M4 0h46c2.21 0 4 1.79 4 4v24.17c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z"
          transform="translate(21 92)"
        />
        <path
          fill="#FFF"
          d="M29.394 23.062c0 .284.257.516.574.516.307 0 .575-.23.575-.516V6.515c0-.284-.258-.515-.575-.515-.307 0-.574.23-.574.515v16.547zm10.196 0c0 .284.258.516.575.516.307 0 .574-.23.574-.516V6.515c0-.284-.257-.515-.574-.515-.307 0-.575.23-.575.515v16.547zm-13.787-.526c0 .577.386 1.042.862 1.042.479 0 .862-.467.862-1.042V7.04c0-.577-.386-1.04-.862-1.04-.478 0-.862.465-.862 1.04v15.496zm6.607 2.92c0 .679.386 1.225.861 1.225.48 0 .862-.549.862-1.225V7.224c0-.679-.386-1.224-.862-1.224-.478 0-.861.547-.861 1.224v18.232zm3.59-2.92c0 .577.386 1.042.862 1.042.479 0 .861-.467.861-1.042V7.04c0-.577-.386-1.04-.861-1.04-.479 0-.862.465-.862 1.04v15.496zm6.606 2.92c0 .678.386 1.225.862 1.225.48 0 .862-.55.862-1.226V7.224c0-.679-.386-1.224-.862-1.224-.478 0-.862.547-.862 1.224v18.231zm-19.819-2.394c0 .284.256.516.575.516.308 0 .574-.23.574-.516V6.515c0-.284-.257-.515-.574-.515-.308 0-.575.23-.575.515v16.547zm-3.59-.526c0 .577.386 1.042.862 1.042.479 0 .861-.467.861-1.042V7.04c0-.577-.386-1.04-.861-1.04-.48 0-.862.465-.862 1.04v15.496zm-3.59 0c0 .577.385 1.042.861 1.042.48 0 .862-.467.862-1.042V7.04c0-.577-.387-1.04-.862-1.04-.478 0-.862.465-.862 1.04v15.496zm-3.017.526c0 .284.257.516.575.516.308 0 .574-.23.574-.516V6.515c0-.284-.256-.515-.574-.515-.308 0-.575.23-.575.515v16.547zM9 25.653c0 .567.387 1.028.862 1.028.479 0 .861-.461.861-1.028V7.026c0-.567-.386-1.026-.861-1.026C9.382 6 9 6.46 9 7.026v18.627zm14.994-.006h6.61v-1.034h-6.61v1.034zm12.063 0h4.576v-1.034h-4.576v1.034zm-15.683 0h2.069v-1.034h-2.069v1.034zm-7.238 0h4.136v-1.034h-4.136v1.034z"
          opacity=".4"
          transform="translate(21 92)"
        />
      </g>
      <g>
        <path
          fill="url(#prefix__b)"
          d="M0 3.333v73.334C0 78.507 1.492 80 3.333 80h60.334C65.507 80 67 78.508 67 76.667V21.58c0-.444-.177-.869-.491-1.182L46.496.485C46.184.175 45.761 0 45.321 0H3.333C1.493 0 0 1.492 0 3.333z"
          opacity=".8"
          transform="translate(86 38)"
        />
        <path
          fill="#8F72C8"
          d="M46.063 0v17.227c0 1.84 1.492 3.333 3.333 3.333h17.337"
          opacity=".4"
          transform="translate(86 38)"
        />
        <g
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.667"
          opacity=".4"
        >
          <path
            d="M0 1.667L35.1 1.667M0 10.417L40.2 10.417M0 18.75L35.1 18.75M0 27.083L19.262 27.083"
            transform="translate(86 38) translate(13.4 37.5)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default EmptyList;
